export const ServiceHost = 'https://service.cmmonhk.com/api'